import { Flex, Menu } from 'antd';
import BrandByCategory, { BrandsByCategory } from 'components/BrandByCategory';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { Viewport } from 'components/ViewportProvider';
import { ContainerState } from 'containers/MainLayout/types';
import React, { Component, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Buyer, Category } from 'types/schema';
import { createSearchQueryfromSlug, getPathSegmentFromSlug } from 'utils/getPathSegmentFromSlug';
import getSelectedCategory from 'utils/getSelectedCategory';
import media from 'utils/mediaStyle';
import utilsMessages from 'utils/messages';
import { generateSlugFromID } from 'utils/urls/categoriesPathSegment';
import { pathnameChecker } from '../../utils/url';
import SVGIcon from '../SVGIcon/SVGIcon';
import Icons from './iconsNewDesign';
import { STATIC_CATEGORY } from './sidebarFilterData';
// import { clarityInvoice, goodDelivery, goodPrice, freeShip, stableOriginal } from 'components/MainNav/GuaranteeImgs';
import { ReactSVG } from 'react-svg';
import { keyframes } from 'styles/styled-components';
import topNavMessage from '../MainNav/messages';
import InvoiceIcon from '../MainNav/NavIcons/InvoiceIcon.svg';
import ReturnIcon from '../MainNav/NavIcons/ReturnIcon.svg';
import SupportIcon from '../MainNav/NavIcons/SupportIcon.svg';
import TruckIcon from '../MainNav/NavIcons/TruckIcon.svg';
import rightArrow from './rightArrow.svg';

import translations from 'translations';

const Icon = styled(SVGIcon)`
  width: 24px;
  height: 24px;
  margin: auto;
  ${({ img }) =>
    img &&
    `
    & > div > img {
      width: 24px;
      height: 24px;
    }
  `}
`;

const IconWrapper = styled.div`
  background: #f2f3f5;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Label = styled.div`
  text-align: left;
  font-size: 14px;
  flex: 1;
  font-weight: 500;
  ${media.lg`
    margin-left: 8px;
  `};
`;

const SubLabel = styled(Link)`
  white-space: nowrap;
  border-radius: 4px;
  transition: all 0.3s ease;
  background-color: white;
  font-weight: 400;
  &:hover,
  &.selected {
    color: #2f904f !important;
  }
`;

const LabelWrapper = styled.div`
  min-width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  text-align: center;
  color: inherit;
  @media (min-width: 1024px) {
    display: flex;
    gap: 5px;
  }
`;

const CategoryNavContainer = styled.nav`
  border-collapse: collapse;
  display: inline-flex;
  flex-direction: row;
  justify-content: start;
  min-width: max-content;
  .ant-menu-horizontal {
    border-bottom: none;
  }
  ${media.lg`
    flex-direction: column;
    background: transparent;
    width: auto;
    .ant-menu-vertical {
      .ant-menu-item.ant-menu-item {
        margin: 0;
      }
      border-right: none;
    }
  `};
  .ant-menu {
    border-radius: 16px !important;
    border: none;
    border-right: none !important;
    font-weight: 400;
    box-shadow: 0 4px 24px 0 rgba(58, 85, 9, 0.04) !important;
    ${({ isScrollable }) =>
      isScrollable &&
      `
      height: 360px;
      overflow-y: auto;
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      scrollbar-width: none; /* Firefox, Safari 18.2+, Chromium 121+ */
      &::-webkit-scrollbar {
        display: none; /* Older Safari and Chromium */
      }
    `}
    border-radius: 6px;
  }
  .ant-menu-submenu .ant-menu-sub {
    padding: 0 8px !important;
  }
  .ant-menu .ant-menu-submenu-title {
    height: auto;
    padding: 4pt;
    line-height: 26px;
    font-weight: 400;

    .ant-menu-submenu-arrow {
      display: none;
    }
    .ant-menu-title-content {
      width: 100%;
    }
  }
  .ant-menu li:last-child {
    .ant-menu-submenu-title {
      border-bottom: none;
    }
  }
  .ant-menu-horizontal > .ant-menu-item,
  .ant-menu-horizontal > .ant-menu-submenu {
    border-bottom: none;
  }
  .ant-menu-submenu:not(:first-child) {
    .ant-menu-submenu-title a {
      /* border-top: 1px solid rgba(158, 158, 158, 0.2); */
    }
  }
`;
const CategoryNavShadow = styled.div`
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: -1;
  position: absolute;
  right: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-color: transparent;
  pointer-events: none;
  display: none;
  ${media.lg`
    display: block;
  `};
`;

const CategoryWrapper = styled.div`
  overflow: visible;
  z-index: 1;
  display: flex;
  ${media.lg`
    z-index: 20;
    top: 100pt;
  `};
  transition: left 0.3s ease-in-out;
  margin-top: 12px;
  .ant-menu-submenu.ant-menu-submenu-popup {
    top: 0px !important;
    left: 232px !important;
    max-height: ${({ wrapperHeight }) => (wrapperHeight ? `${wrapperHeight}px` : '381px')};
    overflow-y: auto;
    .ant-menu {
      box-shadow: unset;
      border: 1px solid rgba(158, 158, 158, 0.2);
      border-top: none;
      border-radius: 6px;
    }
  }

  .submenu-list {
    .ant-menu {
      /* Adjust the height of submenu list to align with the height of nav */
      height: ${({ wrapperHeight }) => (wrapperHeight ? `${wrapperHeight}px` : '100%')};
      min-height: 381px;
      padding-inline: 10px;
      // min-width: 436px;
    }
  }

  .ant-menu-submenu.ant-menu-submenu-popup {
    .ant-menu {
      border-radius: 0 6px 6px 0;
      overflow-y: hidden;
    }
  }
  .ant-menu-sub .ant-menu-item:hover {
    background: unset !important;
    color: #2f904f !important;
  }
`;

const SubMenuList = styled.div`
  min-width: 210px;
`;

const SubMenu = styled(Menu.SubMenu)`
  &:first-of-type {
    a {
      overflow: hidden;
    }
  }
  &:last-of-type {
    a {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      overflow: hidden;
    }
  }
  a {
    background: white;
    transition: background-color 0.3s ease;
  }
  .ant-menu-submenu-title {
    padding: 0 !important;
    color: rgba(0, 0, 0, 0.85);
    a {
      padding: 7px 12px;
      color: inherit;
      display: block;
      &:focus {
        text-decoration: none;
      }
      div {
        align-items: center;
      }
    }
  }
  transition: all 0.3s ease;
  &.selected .ant-menu-submenu-title,
  &:hover .ant-menu-submenu-title {
    color: #2f904f;
  }
`;

export const CategoryContainer = styled.div`
  position: relative;
  ${({ usingPosition }) =>
    usingPosition &&
    `
    position: absolute;
     top: 0;
  `}
  z-index: 100;
  &:before {
    content: '';
    position: absolute;
    top: -20px;
    left: 0;
    width: 100%;
    height: 20px;
    cursor: pointer;
  }
  &:hover {
    display: block;
  }
  &.show-category {
    display: block;
  }
  ${({ disabledStore }) =>
    disabledStore &&
    `
    top: 50px;
  `}
  .ant-menu {
    border: none;
    box-shadow: 0 4px 24px 0 rgba(236, 236, 236, 0.8);
  }
`;
const CategoryMobileContainer = styled.div`
  padding: 16px 0px 0px;
  background: #ffffff;
  margin: 0px;
`;
const CategoryMobileWrapper = styled.div`
  display: flex;
  gap: 8px;
  padding: 0 16px 16px;
  overflow: auto;
  scrollbar-width: none;
  background: #ffffff;
`;

const CategoryMobileItem = styled.div`
  width: 70px;
  flex-shrink: 0;
  a div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    & div {
      font-size: 12px;
      font-weight: 450;
      line-height: 20px;
      color: #343538;
      text-align: center;
      text-wrap: balance;
    }
  }
  a div ${Icon} {
    width: 56px;
    height: 56px;
  }
`;

const MobileIconWrapper = styled.div`
  background: #f2f3f5;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  & svg {
    width: 30px;
  }
`;

const Overlay = styled.div`
  display: ${({ overlay }) => (overlay ? 'block' : 'none')};
  content: '';
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 101px;
  left: 0px;
  background: rgba(66, 66, 66, 0.1);
  z-index: -1;
`;

const SliderSection = styled.div`
  background-color: #ffffff;
  padding-inline: auto;
  padding-top: 12px;
  padding-bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const marqueeMove = keyframes`
  0% {
    transform: translateX(-0%);
  }
  1% {
    transform: translateX(-1%);
  }
  80% {
    transform: translateX(-50.5%);
  }

  99.9% {
    transform: translateX(-50.5%);
  }

  100% {
    transform: translateX(-0%);
  }
`;

const MarqueeSection = styled.div`
  padding: 10px 0 0px;
  background: #f7f7f8;
`;

const MarqueeWrapper = styled.div`
  overflow: hidden;
  position: relative;
  border-radius: 999px;
  padding: 4px 12px;
`;

const MarqueeIcon = styled(SVGIcon)`
  img {
    width: 12px !important;
  }
`;

export const SectionItemText = styled.span`
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '12')}px;
  font-weight: 500;
  color: #2f382c;
  flex-shrink: 0;
`;

export const SectionItemList = styled.div`
  display: flex;
  width: max-content;
  gap: 16px;
  animation: ${marqueeMove} 12s linear infinite;
`;

export const SectionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  ${({ isSeparate }) =>
    isSeparate &&
    `
  &:not(:last-child):after {
    content: '';
    width: 1px;
    height: 20px;
    background: #eaebea;
    margin-left: 16px;
  }
  `}
  ${({ active }) =>
    active &&
    `
    & span {
      color: #43A047;
    }
  `}
  ${({ noCursor }) =>
    noCursor &&
    `
    cursor: auto;
  `}
`;

const MarqueeBoxShadow = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 53px;
  height: 100%;
  background: linear-gradient(270deg, #f0f9f1 9.55%, rgba(240, 249, 241, 0) 68.04%);
`;

const SectionItemFixText = styled.div`
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 8px 0 8px;
  background: rgb(241, 249, 236);
  z-index: 10;
  gap: 4px;
`;

interface CategoryNavState {
  sideNavOpened: boolean;
  categories: Category[];
  buyer: Buyer;
  brandsByCategory: BrandsByCategory[];
  hasScrolled?: boolean;
}
interface CategoryNavProps extends RouteComponentProps {
  main?: ContainerState;
  overlay?: boolean;
  onCloseCategory?: () => void;
  usingPosition?: boolean;
}

const HEIGHT_OF_SUBMENU_ITEM = 38;

export const HeaderMarquee = () => {
  const lang = localStorage.getItem('lang') || 'vi';

  const guaranteeData = useMemo(() => {
    return [
      {
        text: translations(topNavMessage.featureDelivery),
        icon: TruckIcon,
      },
      {
        text: translations(topNavMessage.featureVat),
        icon: InvoiceIcon,
      },
      {
        text: translations(topNavMessage.featureReturn),
        icon: ReturnIcon,
      },
      {
        text: translations(topNavMessage.featureSupport),
        icon: SupportIcon,
      },
    ];
  }, [lang]);
  return (
    <MarqueeSection>
      <MarqueeWrapper>
        <SectionItemList lang={lang}>
          {[...guaranteeData, ...guaranteeData, ...guaranteeData, ...guaranteeData].map((item, index) => (
            <SectionItem key={index} noCursor={true}>
              <MarqueeIcon src={item.icon} />
              <SectionItemText>{item.text}</SectionItemText>
            </SectionItem>
          ))}
        </SectionItemList>
        <MarqueeBoxShadow/>
      </MarqueeWrapper>
    </MarqueeSection>
  );
};

class CategoryNav extends Component<CategoryNavProps, CategoryNavState> {
  public state: CategoryNavState = {
    sideNavOpened: false,
    buyer: {} as Buyer,
    categories: [],
    brandsByCategory: [],
    hasScrolled: false,
  };

  public getSelectedCategory = (searchQuery: string) => {
    const substate = this.props.main;
    return getSelectedCategory(searchQuery, substate && substate.categories);
  };

  public static getDerivedStateFromProps(nextProps: CategoryNavProps) {
    if (nextProps.main) {
      const { sideNav, categories, brandsByCategory, buyer } = nextProps.main;
      return {
        sideNavOpened: sideNav,
        categories: categories,
        brandsByCategory: brandsByCategory,
        buyer: buyer,
      };
    }
    return {
      sideNavOpened: false,
      categories: [],
      brandsByCategory: [],
      buyer: {} as Buyer,
    };
  }

  public handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const scrollLeft = e.currentTarget.scrollLeft;
    const scrollRight = e.currentTarget.scrollWidth - e.currentTarget.clientWidth - scrollLeft;
    if (scrollLeft > 0) {
      this.setState({
        hasScrolled: true,
      });
    } else if (scrollRight > 0) {
      this.setState({
        hasScrolled: false,
      });
    }
  };

  public render() {
    const { sideNavOpened, categories, brandsByCategory, buyer, hasScrolled } = this.state;
    const { location, overlay, onCloseCategory, usingPosition } = this.props;
    const segment = getPathSegmentFromSlug(location);
    const searchQuery = createSearchQueryfromSlug(location, segment);
    const selectedCategory = this.getSelectedCategory(searchQuery);
    const lang = localStorage.getItem('lang') || 'vi';
    const path = pathnameChecker.isFavoritePage(location.pathname) ? '/favorite' : '';
    const currentStore = window.localStorage.getItem('store');
    const region = buyer?.region ? buyer?.region : localStorage.getItem('region');
    return (
      <Viewport.Consumer>
        {({ width }) => {
          const isMobileSize = width < 1024;
          return (
            <ErrorBoundary>
              {!isMobileSize ? (
                <>
                  <CategoryContainer
                    isHomePage={location.pathname === '/'}
                    className={location.pathname === '/' && 'show-category'}
                    disabledStore={
                      !isMobileSize && buyer?.stores?.find((store) => store?.id === currentStore)?.status === 'BLOCKED'
                    }
                    usingPosition={usingPosition}
                  >
                    <CategoryWrapper
                      sideNavOpen={sideNavOpened}
                      id="products-category"
                      wrapperHeight={
                        overlay ? (categories?.length + STATIC_CATEGORY.length) * HEIGHT_OF_SUBMENU_ITEM : undefined
                      }
                    >
                      <CategoryNavContainer isScrollable={!overlay}>
                        <Menu
                          getPopupContainer={() => document.getElementById('products-category') || document.body}
                          style={{ width: 230 }}
                        >
                          {categories?.map((category: Category, _index) => {
                            const targetBrands = brandsByCategory?.find(
                              (brand) => Number(brand.categoryId) === category.id,
                            );
                            return (
                              <SubMenu
                                key={category.name}
                                title={
                                  <Link to={`/${generateSlugFromID(category, lang)}`}>
                                    <LabelWrapper onClick={onCloseCategory}>
                                      {Icons[category?.id || 0] && (
                                        <IconWrapper>
                                          <Icon img={true} src={Icons[category?.id || 0]} />
                                        </IconWrapper>
                                      )}
                                      <Label>{category.nameLocal}</Label>
                                      <Icon src={rightArrow} style={{ marginLeft: 8 }} />
                                    </LabelWrapper>
                                  </Link>
                                }
                                className={
                                  selectedCategory &&
                                  selectedCategory.name.indexOf(category.name) > -1 &&
                                  path !== '/favorite'
                                    ? 'selected'
                                    : ''
                                }
                                popupClassName="submenu-list"
                              >
                                <Flex style={{ height: '100%', width: '100%' }}>
                                  <SubMenuList>
                                    {category.children?.map((subCategory) => (
                                      <>
                                        {subCategory?.id === 81 && region === 'HCM' ? null : (
                                          <Menu.Item
                                            key={subCategory.name}
                                            style={{ padding: 0 }}
                                            onClick={onCloseCategory}
                                          >
                                            <SubLabel
                                              to={`/${generateSlugFromID(subCategory, lang)}`}
                                              className={
                                                selectedCategory && selectedCategory.name === subCategory.name
                                                  ? 'selected'
                                                  : ''
                                              }
                                            >
                                              {subCategory.nameLocal}
                                            </SubLabel>
                                          </Menu.Item>
                                        )}
                                      </>
                                    ))}
                                  </SubMenuList>
                                  <BrandByCategory brands={targetBrands} />
                                </Flex>
                              </SubMenu>
                            );
                          })}
                          {STATIC_CATEGORY.map((item) => (
                            <SubMenu
                              key={item.key}
                              className={location.pathname === item.pathname ? 'selected' : ''}
                              title={
                                <Link to={item.pathname} onClick={onCloseCategory}>
                                  <LabelWrapper>
                                    <Icon img={true} src={Icons[item.id]} />
                                    <Label>
                                      <FormattedMessage {...utilsMessages[item.key]} />
                                    </Label>
                                    <Icon src={rightArrow} style={{ marginLeft: 8 }} />
                                  </LabelWrapper>
                                </Link>
                              }
                            />
                          ))}
                        </Menu>
                      </CategoryNavContainer>
                      <CategoryNavShadow />
                    </CategoryWrapper>
                  </CategoryContainer>
                  <Overlay overlay={overlay} onClick={onCloseCategory} />
                </>
              ) : (
                <>
                  <CategoryMobileContainer>
                    <CategoryMobileWrapper isDisplayFullCategory={categories?.length > 10} onScroll={this.handleScroll}>
                      {categories?.map((category: Category) => {
                        return (
                          <CategoryMobileItem
                            key={category.name}
                            className={
                              selectedCategory &&
                              selectedCategory.name.indexOf(category.name) > -1 &&
                              path !== '/favorite'
                                ? 'selected'
                                : ''
                            }
                            popupClassName="submenu-list"
                          >
                            <Link
                              to={
                                path === '/favorite'
                                  ? `${path}?category=${encodeURIComponent(category.name)}`
                                  : `/${generateSlugFromID(category, lang)}`
                              }
                            >
                              <LabelWrapper>
                                {Icons[category?.id || 0] && (
                                  <MobileIconWrapper>
                                    <ReactSVG src={Icons[category?.id || 0]} />
                                  </MobileIconWrapper>
                                )}
                                <Label>{category.nameLocal}</Label>
                              </LabelWrapper>
                            </Link>
                          </CategoryMobileItem>
                        );
                      })}
                    </CategoryMobileWrapper>
                  </CategoryMobileContainer>
                  {/* {width <= 991 && (
                    <SliderSection>
                      <SliderContainer>
                        <SlideDots active={hasScrolled} />
                      </SliderContainer>
                    </SliderSection>
                  )} */}
                </>
              )}
            </ErrorBoundary>
          );
        }}
      </Viewport.Consumer>
    );
  }
}

export default withRouter(CategoryNav);
